import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 保存群临时成员信息
export function webSaveClusterMemberTemp(clusterId,fanlist,type,callback){
	request({
			method: 'post',
			url: 'ClusterMemberTemp/save',
			data: {
				type:type,
				cluster_id:clusterId,
				fanlist:fanlist
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}